import { useState } from "react";
import Logiteam from "../images/logiteam_logo.png";

export const Navbar = () => {
  const [navbar, setNavbar] = useState(false);

  return (
    <nav className="backdrop-blur sticky top-0 z-50  border-gray-200 px-2 sm:px-4 py-2.5 rounded">
      <div className="justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
        <div>
          <div className="container flex flex-wrap items-center justify-between mx-auto">
            <div className=" flex items-center">
            <a href="/" >
              <img
                src={Logiteam}
                alt={"logiteamlogo"}
                width={100}
                height={30}
              />
            </a>
             <p className="mx-2 mt-2 text-start text-sm text-cyan-900 ">
              By Graiet group
            </p>
          </div>
            <div className="md:hidden">
              <button
                className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                onClick={() => setNavbar(!navbar)}
              >
                {navbar ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>
        <div>
          <div
            className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
              navbar ? "block" : "hidden"
            }`}
          >
            <ul className="flex flex-col p-4 mt-4  bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 bg-transparent ">
              <li>
                <a
                  href="/"
                  className="nav block py-2 pl-3 pr-4 text-lg text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:p-0"
                  aria-current="page"
                >
                  <nav>
                  Accueil
                  
                  </nav>
                  
                </a>
              </li>
              <li>
                <a
                  href="/presentation"
                  className=" nav
                  block py-2 pl-3 pr-4 text-lg text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:p-0"
                  aria-current="page"
                >
                  <nav>
                  Présentation
                  </nav>
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="nav block py-2 pl-3 pr-4 text-lg text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0  md:p-0 "
                >
                  <nav>
                 Pourquoi logiteam?
                 </nav>
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className=" nav block py-2 pl-3 pr-4 text-lg text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:p-0 "
                >
                  <nav>
                  Devenir partenaire
                  </nav>
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="nav block py-2 pl-3 pr-4 text-lg text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:p-0 "
                >
                  <nav>
                  À propos
                  </nav> 
                </a>
              </li>
 
            
            </ul>
            
          </div>
        </div>
      </div>
    </nav>
  );
};
